export const APPLICATION_VERSION = '1.41.46';
